import React from "react";
import { CTAButton, SectionLabel, Reveal, SunRays } from "@/lib/uiHelpers";
import { OFFER_ITEMS } from "@/constants/landingCopy";
import { Check, Zap } from "lucide-react";

export default function OfferStack() {
  return (
    <section className="section-pad relative overflow-hidden" style={{ backgroundColor: "#1A2B4A" }}>
      <SunRays color="#F5A623" opacity={0.1} originX="0%" originY="100%" />
      <div className="container-max relative z-10">
        <Reveal className="text-center max-w-2xl mx-auto">
          <SectionLabel>What&apos;s Included</SectionLabel>
          <h2 className="font-head font-extrabold text-3xl md:text-5xl text-white leading-tight">
            Everything You Get
            <span className="block" style={{ color: "#F5A623" }}>
              When You Go Solar With Us
            </span>
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 gap-x-10 gap-y-5 max-w-4xl mx-auto">
          {OFFER_ITEMS.map((item, i) => (
            <Reveal key={item.bold} delay={(i % 2) * 0.08}>
              <div className="flex items-start gap-3">
                <span
                  className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full"
                  style={{ background: "rgba(39,174,96,0.18)" }}
                >
                  <Check size={17} strokeWidth={3} style={{ color: "#27AE60" }} />
                </span>
                <p className="font-body text-white/85 text-base md:text-lg">
                  <span className="font-bold text-white">{item.bold}</span> {item.rest}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-12 max-w-3xl mx-auto">
          <div
            className="rounded-2xl px-6 py-6 md:px-8"
            style={{ background: "#F5A623", color: "#1A2B4A" }}
          >
            <div className="flex items-center gap-2 font-head font-extrabold text-lg md:text-xl">
              <Zap size={20} fill="#1A2B4A" /> Every Month Is Money to HECO
            </div>
            <p className="font-body mt-2 text-sm md:text-base" style={{ color: "#3a2f12" }}>
              HECO rates remain among the highest in the nation, and every month without solar is
              another oversized bill. The sooner you start, the sooner your savings begin. Let&apos;s
              get your discovery call on the calendar.
            </p>
          </div>
        </Reveal>

        <div className="mt-10 text-center">
          <CTAButton testId="offer-cta" variant="white" className="w-full sm:w-auto">
            &rarr; Book My Free Discovery Call
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
